module.exports = __webpack_public_path__ + "4440769503f3545fb58c6f77d4ecb4cc.png";